import { render, staticRenderFns } from "./common-input.vue?vue&type=template&id=045d9f64&scoped=true&"
import script from "./common-input.vue?vue&type=script&lang=js&"
export * from "./common-input.vue?vue&type=script&lang=js&"
import style0 from "./common-input.vue?vue&type=style&index=0&id=045d9f64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d9f64",
  null
  
)

export default component.exports